import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, UncontrolledCollapse, Button, NavItem } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import { Logotipo, LogoOperadora } from "constants/Logotipo";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

// helpers
import { getSessionCookie } from "utils/cookies";

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.sidebar = React.createRef();
    this.state = {
      logotipo: require('assets/img/logo-white.png'),
      rotate: false
    };
    this.setRotate = this.setRotate.bind(this);
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  sessionData() {
    let dados = {
      userName: "",
      perfil: "",
    }
    let session = getSessionCookie();
    if (session != null) {
      dados.userName = session.nome;
      dados.perfil = session.perfil;
    }
    return dados;
  }

  setRotate() {
    this.setState(prevState => ({
      rotate: !prevState.rotate
    }));
  }

  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo text-center" style={{ minHeight: "60px" }}>
          <img className="mt-2" src={LogoOperadora()} style={{ width: "110px" }} alt="react-logo" />
        </div>
        <div className="logo">
          <div className="mt-2 text-white text-center"><label>Módulo DRE</label></div>
        </div>
        <div className="sidebar-wrapper" ref={this.sidebar}>
          <Nav>
            {this.props.routes.map((prop, key) => {
              if (!prop.submenus) {
                return (
                  <li
                    className={
                      this.activeRoute(prop.path) +
                      (prop.pro ? " active-pro" : "")
                    }

                    Style={prop.sidebar == true ? "display: block" : "display: none"}

                    key={key}
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className={prop.icon} />
                      <p>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              }
              else {
                return (
                  <li
                    className={
                      this.activeRoute(prop.path) +
                      (prop.pro ? " active-pro" : "")
                    }

                    Style={prop.sidebar == true ? "display: block" : "display: none"}

                    key={key}
                  >
                    <NavItem>
                      <NavLink
                        to={prop.layout + prop.path}
                        className="nav-link d-flex align-items-center justify-content-between"
                        activeClassName="active"
                        id={"toggler_" + key}
                        onClick={this.setRotate}
                      >
                        <i className={prop.icon} />
                        <p style={{ marginRight: 35 }}>{prop.name}</p>
                        <i className="fas fa-caret-down" style={{ transform: `rotate(${this.state.rotate ? '180deg' : '0deg'})` }} />
                      </NavLink>
                    </NavItem>
                    <UncontrolledCollapse toggler={"#toggler_" + key} className="collapseMenu">
                      <ul className="submenu list-unstyled">
                        {prop.submenus.map((subprop, subkey) => {
                          return (
                            <li
                              key={subkey}
                            >
                              <NavLink
                                to={prop.layout + subprop.path}
                                className="nav-link"
                                activeClassName="active"
                              >
                                <i className={subprop.icon} />
                                <p>{subprop.name}</p>
                              </NavLink>
                            </li>
                          )
                        }
                        )}
                      </ul>
                    </UncontrolledCollapse>
                  </li>
                );
              }
            })}
          </Nav>
        </div>

      </div>
    );
  }
}

export default Sidebar;
